export default function PunchBottomRewardToast({ events = [], isBurningActive = false }) {
  if (!Array.isArray(events) || events.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-20 z-[45] flex flex-col items-center gap-2 px-6">
      {events.map((event) => {
        const backgroundColor = isBurningActive ? '#000000' : '#ffffff';
        const color = isBurningActive ? '#ffffff' : event.color ?? '#000000';

        return (
          <div
            key={event.id}
            className="punch-reward-toast rounded-lg px-4 py-3 text-center font-['Pretendard'] text-[16px] font-bold leading-none tracking-[-0.4px] shadow-[0_8px_24px_rgba(0,0,0,0.28)]"
            style={{
              backgroundColor,
              color,
            }}
          >
            {event.text}
          </div>
        );
      })}
    </div>
  );
}
